import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const BANK_DETAILS_SCHEMA = Object.freeze({
  ACCOUNT_NUMBER: '',
  ROUTING_NUMBER: '',
  BANK_NAME: '',
});
const RECORD = generateSchema(BANK_DETAILS_SCHEMA);
const KEYS: any = generateKeys(BANK_DETAILS_SCHEMA);

export class BankDetails extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get accountNumber(): string {
    return this.get(KEYS.ACCOUNT_NUMBER);
  }

  get routingNumber(): string {
    return this.get(KEYS.ROUTING_NUMBER);
  }

  get bankName(): string {
    return this.get(KEYS.BANK_NAME);
  }
}
